<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path data-follow-fill="currentColor" d="M3.1 15.2c-.5 0-1-.5-1-1V9.8c0-.5.5-1 1-1s1 .5 1 1v4.4c0 .7-.3 1-1 1z" :fill="_fill" />
      <path data-follow-fill="currentColor" d="M5.4 22.9c-1.9 0-3.3-1.5-3.3-3.3v-.4c0-.5.5-1 1-1s1 .5 1 1v.4c0 .7.6 1.3 1.3 1.3h12.7c.7 0 1.3-.6 1.3-1.3v-5.2c-1-.4-1.6-1.3-1.6-2.3 0-1 .8-2 1.6-2.3V4.5c0-.7-.6-1.3-1.3-1.3H5.4c-.7 0-1.3.6-1.3 1.3v.4c0 .5-.5 1-1 1s-1-.5-1-1v-.4c0-.9.3-1.8 1-2.4.6-.6 1.4-1 2.3-1H18c.9 0 1.8.3 2.4 1 .6.6 1 1.5 1 2.4v5.2c1 .3 1.6 1.2 1.6 2.3 0 1.1-.5 2-1.5 2.5v5.1c0 .9-.3 1.8-1 2.4-.6.6-1.4 1-2.3 1H5.4zm15.1-11.8c-.6 0-.9.5-.9.9 0 .2.1.5.3.6.2.2.4.3.6.3.5 0 .8-.5.9-.9 0-.5-.3-.9-.9-.9z" :fill="_fill" />
      <path data-follow-fill="currentColor" d="M8.4 17.7c-.5 0-1-.5-1-1s.5-1 1-1h6.7c.5 0 1 .5 1 1 0 .7-.5 1-1 1H8.4zm-6.4 0c-.5 0-1-.5-1-1s.5-1 1-1h2.3c.5 0 1 .5 1 1 0 .7-.5 1-1 1H2zm6.4-4.6c-.5 0-1-.3-1-1 0-.5.5-1 1-1h6.7c.5 0 1 .5 1 1 0 .7-.5 1-1 1H8.4zM2 8.4c-.7 0-1-.4-1-1 0-.5.3-1 1-1h2.3c.5 0 1 .5 1 1 0 .7-.5 1-1 1H2zm6.4 0c-.5 0-1-.3-1-1 0-.5.5-1 1-1h6.7c.5 0 1 .5 1 1 0 .7-.5 1-1 1H8.4z" :fill="_fill" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
